import { useSelector } from "react-redux";

export function usePostFieldNames() {
    const fieldNames = useSelector(state => state.org_helper.organization.post_field_names);
    return fieldNames;
}
